<template>
	<Layout>
		<div class="PortfolioPage EcoAIBigData">
			<div class="PortfolioPage_content">
				<div class="staticBanner" v-for="(item, index) in Bannerlist[0]" :key="index">
					<img class="img-bg" :src="item.bg" alt="">
					<div class="text color-white " data-aos="fade-up">
						<h4 class="staticimg-title color-white fs-1">{{ item.title }}</h4>
						<div class="staticimg-content fs-3">{{ item.title2 }}</div>
						<div class="input-btn">
							<input class="input" type="text" placeholder="请输入您的手机号码">
							<button class="free-btn btn" @click="orderShow">免费试用</button>
						</div>
						<div class="scroll">
							<div class="fs-3">500+ 大型集团企业共同选择</div>
							<div class="company animate__animated">
								<vue-seamless-scroll :data="companyall" :class-option="defaultOption">
									<div class="companymain">
										<div class="companyitem" v-for="(log, j) in companyall">
											<img class="logoimg" :src="log.logo" alt="">
										</div>
									</div>
								</vue-seamless-scroll>
							</div>
						</div>
					</div>
				</div>
				<!-- <dropdownMenu :pkname="'数据平台'"></dropdownMenu> -->
				<div class="titles" v-if="windowWidth > 767">
					<div class="in_titles">
						<div class="in_titles_left">
							<img class="in_titles_left_img" src="../assets/images/industry/tb.png" alt="" />
							<div><span style="margin-right: 10px">&gt;</span><span style="font-size: 18px">数据平台</span>
							</div>
						</div>
					</div>
				</div>

				<div class="title container" id="title">
					<div class="tab-block pt-lyd-120 container">
						<div class="fs-1 fw-bold text-center lyd-title-colo1" data-aos="fade-up">基于大模型的数据智能体平台</div>
						<div class='fs-3 text-center lyd-title-colo1 title_div' data-aos="fade-up">
							博信诚ECOP企业级一站式数据中台崭露头角，为企业提供了一站式的数据解决方案。它能够有效打破数据孤岛，实现数据的统一管理和高效流通，确保数据在企业内部无缝共享与协同。通过集成先进的数据分析工具和技术，博信诚ECOP数据中台能够将海量数据转化为有价值的洞察和决策依据，
							从而助力企业在数字化浪潮中稳健前行，实现可持续发展。
						</div>
						<img src="@/assets/images/EcoAIBigData/Architecture_大数据_image@2x.png" alt="">
					</div>
				</div>

				<div class="model">
					<ModelBox key="hx1" :val="2" :claWidth="claWidth" :modelBox="modelBox" mainTitle="核心功能"
						subTitle="构建高效数据生态的核心枢纽" :showButton="false" :enableImageScale="false"
						:backgroundImage="require('@/assets/images/EcoAIBigData/hexingongneng_bj_image@2x.jpg')">
					</ModelBox>
				</div>
				<div class="model model2">
					<ModelBox key="hx2" :val="1" :claWidth="claWidth" :modelBox="modelBox" mainTitle="核心优势"
						subTitle="构建高效数据生态的核心枢纽" :showButton="false" :enableImageScale="false"
						:backgroundImage="require('@/assets/images/EcoAIBigData/hexinyoushi_bj_image@2x.jpg')">
					</ModelBox>
				</div>

			</div>
		</div>
	</Layout>
</template>
<style lang="scss">
.EcoAIBigData {
	.model2 .modelBoxss {
		margin-top: 0 !important;
	}

	.modelBoxss .bottom-list .hoverClass1 .moreBoxImg2 {
		width: 100%;
		height: 100%
	}

	.modelBoxss .bottom-list .moreBox .moreBoxImg3 {
		border-radius: 8px;
	}

	.modelBoxss .bottom-list .moreBox .moreBoxImg2 {
		width: 100%;
		height: 100%;
		border-radius: 8px;
	}

	.title {
		display: flex;
		justify-content: center;
		align-items: center;
		padding-bottom: 5%;

		.title_div {
			// padding: 0 17rem;
			margin-bottom: 5rem;
		}
	}
}

.mt-20 {
	margin-top: 2rem;
}
</style>
<style lang="scss">
.dislog {
	position: relative;
	z-index: 10;
	display: none;
	width: 100vw;
}

.moveEsc {
	position: relative;
	z-index: 10;
	display: none;
	width: 100vw;
}

#disable {
	position: fixed;
	top: 0;
	height: 100%;
	overflow: hidden;
}
</style>
<script>
import dislog from '@/views/TeamESCPage.vue'
import moveEsc from '@/views/moveEscPage.vue'
import Layout from "../components/common/Layout"
import StaticBanner from "@/components/common/staticBanner/index.vue"
import ListCard from "@/components/common/relatedCases/listCard"
import dropdownMenu from "@/components/common/dropdownMenu.vue"
import "swiper/dist/css/swiper.css"
import { swiper, swiperSlide } from "vue-awesome-swiper"
import OrderShow from '@/components/common/dialog/orderShow.vue'
import vueSeamlessScroll from 'vue-seamless-scroll'

import ModelBox from "@/components/common/counter/ModelBox.vue"
export default {
	name: "EcoAIBigData",
	components: {
		Layout,
		StaticBanner,
		ListCard,
		swiper,
		swiperSlide,
		vueSeamlessScroll,
		dislog,
		dropdownMenu,
		OrderShow,
		moveEsc,
		ModelBox
	},
	data() {
		return {
			windowWidth: document.documentElement.clientWidth,
			claWidth: 'col-lg-6',
			Bannerlist: [
				[{
					bg: require('@/assets/images/EcoAIBigData/EcoAIBigData-banner.jpg'),
					title: '基于大模型的数据智能体平台',
					title2: '构建高效数据生态的核心枢纽'
				}]
			],
			modelBox: [
				[{
					img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
					title1: "多租户管理",
					title2: "采用资源队列技术实现资源隔离，支持基于计算节点和CPU+内存组合的多租户管理模式，并可根据资源池的百分比或固定值灵活分配资源，精准满足不同租户的资源需求。",
				},
				{
					img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
					title1: "数据调度",
					title2: "全面涵盖任务编排、资源管理、监控与告警、容错与重试机制、调度策略以及数据一致性与完整性保障，确保数据处理流程高效、稳定且可靠。",
				},
				{
					img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
					title1: "数据模型管理",
					title2: "内置经过实战检验的数据规范，支持多种行业建模规范的灵活配置，将传统依赖人工经验与约定的模式转变为系统化的规范方式。同时，兼容常用的关系型数据库和大数据存储，能够满足绝大多数数据质量校验场景的需求。",
				},
				{
					img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
					title1: "数据API",
					title2: "通过标准化接口形式，将数据以服务化的方式提供给前端应用。支持多种数据格式，具备实时查询、批量获取和推送功能，同时具备高并发处理能力、数据安全性和权限管理功能，确保数据在传输过程中的安全性和合规性。",
				}],
				[{
					img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
					title1: "数据采集与清洗",
					title2: "从内外部数据源采集并清洗数据，并确保数据的准确性和完整性",
				},
				{
					img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
					title1: "数据存储与管理",
					title2: "建立高效的数据存储方式，并进行数据分类、标注和权限管理",
				},
				{
					img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
					title1: "数据处理与分析",
					title2: "进行数据挖掘、建模和可视化，发现数据价值，支持企业决策",
				},
				{
					img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
					title1: "数据应用与开放",
					title2: "将处理后分析结果以及数据，通过API或其他接口向内部和外部系统开放，实现数据价值",
				},
				{
					img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
					title1: "数据安全与合规",
					title2: "确保数据安全性、完整性和可用性，遵守法律法规和标准，保护数据权益",
				},
				{
					img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
					title1: "数据治理与资产化",
					title2: "制定数据标准、数据质量控制、数据访问权限管理等，推动数据资产化",
				},
				{
					img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
					title1: "数据服务与共享",
					title2: "通过API、数据目录等，数据标准等方式提供数据服务，支持跨部门和跨组织的数据共享",
				}
				]
			],
			demoPages: [
				[{
					url: "/success-detail/6",
					image: require("@/assets/images/casesimg/zhongye-zhiye.png"),
					imageLight: require("@/assets/images/casesimg/zhongye-zhiye.png"),
					title: "中冶置业",
					content: "地产企业业财融合智慧创新管理标杆",
				},
				{
					url: "/success-detail/7",
					image: require("@/assets/images/casesimg/jiaotong.png"),
					imageLight: require("@/assets/images/casesimg/jiaotong.png"),
					title: "中冶交通",
					content: "智能业财管理助力财务管控更高效",
				},
				{
					url: "/success-detail/8",
					image: require("@/assets/images/casesimg/huaxiafenmo.png"),
					imageLight: require("@/assets/images/casesimg/huaxiafenmo.png"),
					title: "华夏粉末冶金",
					content: "业财一体化应用为制造企业转型升级赋能",
				},
				{
					url: "/success-detail/1",
					image: require("@/assets/images/casesimg/guolv-new.png"),
					imageLight: require("@/assets/images/casesimg/guolv-new.png"),
					title: "中国国旅",
					content: "全球化财务共享中心管理",
				}
				],
				[{
					url: "/success-detail/2",
					image: require("@/assets/images/casesimg/botian-new.png"),
					imageLight: require("@/assets/images/casesimg/botian-new.png"),
					title: "博天环境 ",
					content: "智慧业财新共享平台",
				},
				{
					url: "/success-detail/3",
					image: require("@/assets/images/casesimg/shanghai-baoye.png"),
					imageLight: require("@/assets/images/casesimg/shanghai-baoye.png"),
					title: "上海宝冶",
					content: "打造一流的最具竞争优势核理念",
				},
				{
					url: "/success-detail/4",
					image: require("@/assets/images/casesimg/zhongliang.png"),
					imageLight: require("@/assets/images/casesimg/zhongliang.png"),
					title: "中梁控股集团",
					content: "支持中梁未来3000亿规模发展",
				},
				{
					url: "/success-detail/5",
					image: require("@/assets/images/casesimg/enfei-new.png"),
					imageLight: require("@/assets/images/casesimg/enfei-new.png"),
					title: "中国恩菲",
					content: "财务共享平台加速中国恩菲一路一带",
				},
				],
				[{
					url: "/success-detail/4",
					image: require("@/assets/images/casesimg/zhongliang.png"),
					imageLight: require("@/assets/images/casesimg/zhongliang.png"),
					title: "中梁控股集团",
					content: "支持中梁未来3000亿规模发展",
				},
				{
					url: "/success-detail/5",
					image: require("@/assets/images/casesimg/enfei-new.png"),
					imageLight: require("@/assets/images/casesimg/enfei-new.png"),
					title: "中国恩菲",
					content: "财务共享平台加速中国恩菲一路一带",
				},
				{
					url: "/success-detail/6",
					image: require("@/assets/images/casesimg/zhongye-zhiye.png"),
					imageLight: require("@/assets/images/casesimg/zhongye-zhiye.png"),
					title: "中冶置业",
					content: "地产企业业财融合智慧创新管理标杆",
				},
				{
					url: "/success-detail/7",
					image: require("@/assets/images/casesimg/jiaotong.png"),
					imageLight: require("@/assets/images/casesimg/jiaotong.png"),
					title: "中冶交通",
					content: "智能业财管理助力财务管控更高效",
				},
				],
				[{
					url: "/success-detail/7",
					image: require("@/assets/images/casesimg/jiaotong.png"),
					imageLight: require("@/assets/images/casesimg/jiaotong.png"),
					title: "中冶交通",
					content: "智能业财管理助力财务管控更高效",
				},
				{
					url: "/success-detail/8",
					image: require("@/assets/images/casesimg/huaxiafenmo.png"),
					imageLight: require("@/assets/images/casesimg/huaxiafenmo.png"),
					title: "华夏粉末冶金",
					content: "业财一体化应用为制造企业转型升级赋能",
				},
				{
					url: "/success-detail/1",
					image: require("@/assets/images/casesimg/guolv-new.png"),
					imageLight: require("@/assets/images/casesimg/guolv-new.png"),
					title: "中国国旅",
					content: "全球化财务共享中心管理",
				},
				{
					url: "/success-detail/2",
					image: require("@/assets/images/casesimg/botian-new.png"),
					imageLight: require("@/assets/images/casesimg/botian-new.png"),
					title: "博天环境 ",
					content: "智慧业财新共享平台",
				}
				]
			],
			demoClass: "col-lg-3 col-md-6 col-12",
			val: "1",
			swiperOption: {
				speed: 1000,
				slidesPerView: 1,
				centeredSlides: false,
				spaceBetween: 20,
				loop: true,
				autoplay: true,
				pagination: {
					el: ".swiper-pagination4",
					// clickable: true,
				},
				on: {
					slideChangeTransitionStart: () => {
						this.slideChangeTransitionStartHandle()
					},
				},
				observer: true,
				observeParents: true,
			},
			leftInd: 0,
			leftCur: 0,
			swiperOptions: {
				speed: 1000,
				slidesPerView: 1,
				centeredSlides: false,
				spaceBetween: 20,
				loop: true,
				autoplay: true,
				pagination: {
					el: ".swiper-pagination1",
					clickable: true,
				},
				observer: true,
				observeParents: true,
			},
			swiperOption23: {
				speed: 1000,
				slidesPerView: 1,
				spaceBetween: 20,
				loop: false,
				autoplay: true,
				observer: true,
				observeParents: true,
			},
			swiperOptionAll: {
				speed: 1000,
				slidesPerView: 1,
				centeredSlides: false,
				spaceBetween: 20,
				loop: true,
				autoplay: true,
				observer: true,
				observeParents: true,
			},
			valueData: [{
				title: "颠覆传统",
				content: "改变财务手工记账方式，智能收取各类事项及交易信息，自动生成会计凭证",
			},
			{
				title: "实时更新",
				content: "报表数据实时变化更新，并对关键交易信息进行分析查询，动态掌握经营情况变化",
			},
			{
				title: "科学查询",
				content: "可通过科目、辅助核算维度组合查询，任意科学查询，敏捷线上生成可用报表",
			},
			{
				title: "一体化应用",
				content: "通过会计平台直达业务系统实现业财深度融合及一体化应用",
			},
			],
			companyall: [{
				logo: require('@/assets/images/home/anli/guolv.png'),
			}, {
				logo: require('@/assets/images/home/anli/botian.png'),
			}, {
				logo: require('@/assets/images/home/anli/zhiye.png'),
			}, {
				logo: require('@/assets/images/home/anli/chinazh.png'),
			}, {
				logo: require('@/assets/images/home/anli/luoyangzg.png'),
			}, {
				logo: require('@/assets/images/home/anli/chinams.png'),
			}, {
				logo: require('@/assets/images/home/anli/baoye.png'),
			}, {
				logo: require('@/assets/images/home/anli/zl.png'),
			}, {
				logo: require('@/assets/images/home/anli/enf.png'),
			}, {
				logo: require('@/assets/images/home/anli/jingye.png'),
			}, {
				logo: require('@/assets/images/home/anli/gangzhonglv.png'),
			}, {
				logo: require('@/assets/images/home/anli/meinuo.png'),
			}, {
				logo: require('@/assets/images/home/anli/zhongguojingye.png'),
			}, {
				logo: require('@/assets/images/home/anli/dutyzero.png'),
			}, {
				logo: require('@/assets/images/home/anli/19.png'),
			}, {
				logo: require('@/assets/images/home/anli/guoyao.jpg'),
			}, {
				logo: require('@/assets/images/home/anli/enfeihuaibao.png'),
			}, {
				logo: require('@/assets/images/home/anli/huiruizhiyao.gif'),
			}, {
				logo: require('@/assets/images/home/anli/nbtm.png'),
			}, {
				logo: require('@/assets/images/home/anli/boe.png'),
			}, {
				logo: require('@/assets/images/home/anli/shandongjingmi.png'),
			}, {
				logo: require('@/assets/images/home/anli/rsms.png'),
			}, {
				logo: require('@/assets/images/home/anli/nanjyy.png'),
			}, {
				logo: require('@/assets/images/home/anli/xinlvyao.png'),
			}, {
				logo: require('@/assets/images/home/anli/wuhanshizhongxinyiy.png'),
			}, {
				logo: require('@/assets/images/home/anli/aolinteyaoye.png'),
			}],

			modelBox1: [{
				bg: require("../assets/images/portfolio/1.jpg"),
				title: "智能合同管理",
				text: "以项目、合同为源头的全生命周期的智能合同管理，包含合同评审、合同签订、合同变更、合同结算、合同发票、合同收付款管理。",
				p: "以项目、合同为源头的全生命周期的智能合同管理，包含合同评审、合同签订、合同变更、合同结算、合同发票、合同收付款管理。",
			},
			{
				bg: require("../assets/images/portfolio/2.jpg"),
				title: "各类型合同签订",
				text: "支持各类合同及电子合同的签订",
				p: "支持各类合同及电子合同的签订",
			},
			{
				bg: require("../assets/images/portfolio/3.jpg"),
				title: "行业特色应用",
				text: "支持建筑行业的建造成本管理、建安收支管理等",
				p: "支持建筑行业的建造成本管理、建安收支管理等",
			},
			],
			modelBox2: [
				[{
					bg: require("../assets/images/portfolio/esc/model2-1.jpg"),
					title: "智能报账",
					text: "实现零人工成本发票自动核验",
					p: "",
				},
				{
					bg: require("../assets/images/portfolio/esc/model2-2.jpg"),
					title: "发票管理",
					text: "适用于多种业务报账场景",
					p: "",
				},
				{
					bg: require("../assets/images/portfolio/esc/model2-3.jpg"),
					title: "电子影像与档案管理",
					text: "实现业务系统运营集中化、纸质单据影像化、业务流程处理便捷化",
					p: "",
				},
				{
					bg: require("../assets/images/portfolio/esc/model2-4.jpg"),
					title: "一键报税",
					text: "自动进行价税分离，满足增值税核算要求",
					p: "",
				},
				{
					bg: require("../assets/images/portfolio/esc/model2-5.jpg"),
					title: "资金结算",
					text: "提升结算效率，加速资金流转，提升整体效益",
					p: "",
				},
				{
					bg: require("../assets/images/portfolio/esc/model2-6.jpg"),
					title: "移动应用",
					text: "移动报销、移动审批",
					p: "",
				},
				{
					bg: require("../assets/images/portfolio/esc/model2-7.jpg"),
					title: "连接器",
					text: "通过统一数据连接器充分结合，让连接+报账实现业财的全面融合",
					p: "",
				},
				{
					bg: require("../assets/images/portfolio/esc/model2-8.jpg"),
					title: "会计引擎",
					text: "可通过ESCloud会计引擎，智能化、自动化生成财务核算系统凭证，实现智能记账",
					p: "",
				},
				{
					bg: require("../assets/images/portfolio/esc/model2-9.jpg"),
					title: "项目管理",
					text: "加强公司对项目全过程管控能力，降低项目风险",
					p: "",
				},
				],
				[{
					bg: require("../assets/images/portfolio/esc/model3-1.jpg"),
					title: "预算管理",
					text: "数据赋能业务，伴随企业成长",
					p: "",
				},
				{
					bg: require("../assets/images/portfolio/esc/model3-2.jpg"),
					title: "智能报表",
					text: "加速内部资金周转，降低资金沉淀量，提高整体资金使用效益",
					p: "",
				},
				{
					bg: require("../assets/images/portfolio/esc/model3-3.jpg"),
					title: "智能分析管理",
					text: "实现业务系统运营集中化、纸质单据影像化、业务流程处理便捷化",
					p: "",
				}
				]
			],
			valueBox: [
				[{
					img1: require("@/assets/images/portfolio/eec/01/value-icon1.png"),
					img2: require("@/assets/images/portfolio/eec/01/value-icon1-blue.png"),
					text: "关键节点预警",
					text2: "对合同进度、结款等关键节点的预警，具体实施进度随时掌握",
				},
				{
					img1: require("@/assets/images/portfolio/eec/01/1589642.png"),
					img2: require("@/assets/images/portfolio/eec/01/1589642-01.png"),
					text: "合同台账预警",
					text2: "避免因业务流程复杂导致的合同生命周期过长",
				},
				{
					img1: require("@/assets/images/portfolio/eec/01/value-icon3.png"),
					img2: require("@/assets/images/portfolio/eec/01/value-icon3_blue.png"),
					text: "合同的履行",
					text2: "避免因工作繁忙导致对合同的重要节点把控不及时",
				},
				{
					img1: require("@/assets/images/portfolio/eec/value-icon03-04.png"),
					img2: require("@/assets/images/portfolio/eec/value-icon03-04_blue.png"),
					text: "业务间流程贯通",
					text2: "满足业务间流程的贯通，合同数据的抽取，大大降低时间成本",
				},
				],
				[{
					img1: require("@/assets/images/portfolio/eec/01/1589642.png"),
					img2: require("@/assets/images/portfolio/eec/01/1589642-01.png"),
					text: "合同管理智能化",
					text2: "全生命周期的智能合同管理，系统化的合同合规控制及合同台账预警",
				},
				{
					img1: require("@/assets/images/portfolio/eec/02/value-icon3.png"),
					img2: require("@/assets/images/portfolio/eec/02/value-icon3_blue.png"),
					text: "业财管理一体化",
					text2: "构建企业全员应用的业财平台，实现从申请到采购、报销入账等全流程一体化管理，并通过对公结算、智能化的诊断与审核、不断优化报销及核算流程，提升效率",
				},
				{
					img1: require("@/assets/images/portfolio/eec/value-icon03-01.png"),
					img2: require("@/assets/images/portfolio/eec/value-icon03-01_blue.png"),
					text: "核算自动化",
					text2: "满足不同业态、多法人结构下多准则、多币种、不同的核算体系，自动化、智能化生产不同会计账簿会计凭证",
				},
				{
					img1: require("@/assets/images/portfolio/eec/value-icon03-02.png"),
					img2: require("@/assets/images/portfolio/eec/value-icon03-02_blue.png"),
					text: "决策和分析精准化",
					text2: "深度分析业务、看清未来态势、将趋势抓得更准确，进行精准的业务诊断分析，做好整个综合业绩管理的闭环",
				},
				],
				[{
					img1: require("@/assets/images/portfolio/eec/value-icon03-03.png"),
					img2: require("@/assets/images/portfolio/eec/value-icon03-03_blue.png"),
					text: "一站式智能决策与分析的经营管理平台",
					text2: "覆盖智能分析，全面预算，分析报表。搭建业财一体绩效指标体系，指引企业经营策略",
				},
				{
					img1: require("@/assets/images/portfolio/eec/value-icon03-04.png"),
					img2: require("@/assets/images/portfolio/eec/value-icon03-04_blue.png"),
					text: "一键实时获取经营数据",
					text2: "通过业财融合实时数据，还原经营状况，支撑智能决策",
				},
				{
					img1: require("@/assets/images/industry/tbcore.png"),
					img2: require("@/assets/images/industry/1-lanse.png"),
					text: "为用户量身打造",
					text2: "无需具备专业IT技能或繁琐培训业务用户即可轻松上手",
				},
				],
				[{
					img1: require("@/assets/images/portfolio/eec/value-icon04-02.png"),
					img2: require("@/assets/images/portfolio/eec/value-icon04-02_blue.png"),
					text: "满足各类财务管理要求",
					text2: "适合于行业的企业扩展性的系统架构、组织变革的需要，满足不同阶段企业财务管理的要求。",
				},
				{
					img1: require("@/assets/images/portfolio/eec/value-icon04-03.png"),
					img2: require("@/assets/images/portfolio/eec/value-icon04-03_blue.png"),
					text: "满足各类核算需求",
					text2: "针对不同的会计准则和税法，灵活配置的会计科目和核算体系，满足不同国家和地区企业会计的核算需求。",
				},
				{
					img1: require("@/assets/images/portfolio/eec/value-icon04-04.png"),
					img2: require("@/assets/images/portfolio/eec/value-icon04-04_blue.png"),
					text: "输出多套核算数据",
					text2: "满足会计、税务和管理上的要求，按不同用户角色需求，以同一套原始凭证需求为基础，输出多套不同用途的核算数据。",
				},
				{
					img1: require("@/assets/images/portfolio/eec/value-icon05-01.png"),
					img2: require("@/assets/images/portfolio/eec/value-icon05-01_blue.png"),
					text: "核算工作全程在线完成",
					text2: "核算全程在线完成，无需人工干预，实现会计核算工作的标准化，规范化，自动化，提升财务内控水平。",
				},
				],
			],
			valueImg: [
				[{ img: require("@/assets/images/portfolio/esc/value/01/value-bg.png") }],
				[{ img: require("@/assets/images/portfolio/esc/value/02/value-bg.png") }],
				[{ img: require("@/assets/images/portfolio/esc/value/03/value-bg.png") }],
				[{ img: require("@/assets/images/portfolio/esc/value/04/value-bg.png") }],
			],
			groupData: [
				[{
					title: "智能合同管理平台",
					title1: "以项目、合同为主线，帮助企业业务、财务部门加强合同的过程管理与控制。它支持企业对以自身为当事人的合同依法进行录入登记、审批、履约、变更、冻结、终止等一系列活动，有助于降低企业资金风险，提高部门协作效率。",
					img1: "",
					img2: require("@/assets/images/portfolio/esc/03-01.png"),
				},],
				[{
					title: "智慧业财管理平台",
					title1: "智慧业财管理是包含智能报账、发票管理、一键报税、资金结算、电子影像和电子档案和智能技术、移动应用、项目管理和行业属性等全场景、一站式的业财一体化管理平台，将各类业务申请前移至各种业务场景的业务报账单,实现“业、财、税、资、档”的横向贯通。结合移动互联网技术,实现移动报账、移动审批、移动分析等功能,为各级员工及领导提供高效便捷的工作体验。",
					img1: "",
					img2: require("@/assets/images/portfolio/esc/03-02.png"),
				},],
				[{
					title: "智能决策与分析经营管理平台",
					title1: "ESCloud智能决策与分析经营管理平台通过业财融合，能够深度分析业务、看清业务未来态势、将趋势抓得更准确，是成长型企业经营管理的重要目标。ESCloud能够实现更加精准的业务诊断分析，做好整个综合业绩管理的闭环。",
					img1: "",
					img2: require("@/assets/images/portfolio/esc/03-03.png"),
				},],
				[{
					title: "智能核算",
					title1: "ESCLoud智能核算满足多核算体系、多准则、多币种、多法人结构下、不同业态的核算平台，通过业财一体化，自动化、智能化生成不同会计账薄的会计凭证。提供包括总账、往来、出纳在内的财务核算等精细化管理核算，同时为企业提供无纸化的电子会计档案，基于RPA、大数据等技术，实现企业财务核算的智能化",
					img1: "",
					img2: require("@/assets/images/portfolio/esc/03-04.png"),
				},],
			],
			valuessImg: [
				[{
					image: require("@/assets/images/portfolio/esc/valuess-01.png"),
				},],
				[{
					image: require("@/assets/images/portfolio/esc/valuess-02.png"),
				},],
				[{
					image: require("@/assets/images/portfolio/esc/valuess-03.png"),
				},],
				[{
					image: require("@/assets/images/portfolio/esc/valuess-04.png"),
				},],
			],
			shows: false,
		}
	},
	created() {
		this.valType()
	},
	computed: {
		defaultOption() {
			return {
				step: 0.3, // 数值越大速度滚动越快
				limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 2, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			}
		},
	},
	watch: {
		$route() {
			this.valType()
			this.toclose()
		}
	},
	mounted() {
		console.log("页面实时宽度", this.windowWidth)
		console.log(this.Swiper)
	},
	methods: {
		btns(type) {
			this.leftInd = type
			this.leftCur = type
			document.getElementById('dislog').style.display = "inline-block"
		},
		btnBox(type) {
			this.leftInd = type
			document.getElementById('moveEsc').style.display = "inline-block"
			let _scrollTop = document.scrollingElement.scrollTop
			document.body.style.position = 'fixed'
			document.body.style.top = -_scrollTop + 'px'
		},
		changevalue(type) {
			console.log(type);
			this.leftInd = type
		},
		toclose() {
			document.getElementById('dislog').style.display = "none"
			document.getElementById('moveEsc').style.display = "none"
			document.body.style.position = ''
			document.body.style.top = ''
		},
		slideChangeTransitionStartHandle() {
			let swiper = this.$refs.Swipers.swiper ? this.$refs.Swipers.swiper.realIndex : 0
			for (let i = 1; i < 5; i++) {
				let ids1 = i + "1"
				let ids2 = i + "2"
				if (document.getElementById(ids1).getAttribute("class").indexOf('line') != -1) {
					document.getElementById(ids1).classList.remove("line")
				}
				if (document.getElementById(ids2).getAttribute("class").indexOf('content') != -1) {
					document.getElementById(ids2).classList.remove("content")
				}
			}
			for (let i = 1; i < Number(swiper) + 2; i++) {
				let ids1 = i + "1"
				let ids2 = i + "2"
				document.getElementById(ids1).setAttribute("class", "line")
				document.getElementById(ids2).setAttribute("class", "content")
			}
		},
		title(val) {
			this.$router.push({
				path: '/portfolio/' + val
			})
			this.val = val
		},
		valType() {
			this.val = this.$route.params.type
		},
		goRouter() {
			this.$router.push({
				path: "/call-us"
			})
		},
		orderShow() {
			this.shows = true
		},
		close() {
			this.shows = false
		},
	},
}
</script>